// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__V1QRN","badges":"styles_badges__CM--w"};